export default __webpack_public_path__ + "static/media/goopter-ecommerce-rewards-loyalty-giftcards.7c833883.png";